import RepositoryFactory from "@/marcom/Apicall/RepositoryFactory";
// const smsCampaign = RepositoryFactory.smsCampaign;

export default {
  createSmsCampaign({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await RepositoryFactory.smsCampaign.createSmsCampaign(
          payload
        );

        commit("SET_SMS_CAMPAIGN_DETAILS", { key: "smss", value: data.data });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  createSmsTemplate({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("SmsTemplate api called");
        const { data } = await RepositoryFactory.smsCampaign.createSmsTemplate(
          payload
        );

        commit("SET_SMS_TEMPLATE_DETAILS", {
          key: "smsTemplates",
          value: data.data,
        });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getSmsTemplate({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Getting all SmsTemplate api called");
        const { data } = await RepositoryFactory.smsCampaign.getSmsTemplate(
          payload
        );

        // commit("SET_SMS_TEMPLATE_DETAILS");

        resolve(data.data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  getSmsConfig({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Getting all SmsConfig api called");
        const { data } = await RepositoryFactory.smsCampaign.getSmsConfig(
          payload
        );
        resolve(data.data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  createSmsConfig({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("Getting all SmsConfig api called");
        const { data } = await RepositoryFactory.smsCampaign.createSmsConfig(
          payload
        );
        resolve(data.data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
